import { createHazardScoreBadge } from '../ScoreBadge'

export const scoreColor = {
  1: '#44dd2e',
  2: '#c5fb48',
  3: '#fefd94',
  4: '#f8b72b',
  5: '#c32d13',
}

export function categoryToLabel(category: number): string {
  /**
   * Convert category integer to label
   *
   * @param category - int
   * @return Category label
   */
  category = Math.round(category)
  if (category === 1) {
    return 'Very Low'
  } else if (category === 2) {
    return 'Low'
  } else if (category === 3) {
    return 'Moderate'
  } else if (category === 4) {
    return 'High'
  } else if (category === 5) {
    return 'Very High'
  } else {
    return 'Unknown'
  }
}

export function categoryToColor(category: number): string {
  /**
   * Convert category integer to color hex code
   *
   * @param category - int
   * @return Category color hex code
   */
  category = Math.round(category)
  return scoreColor?.[category] ?? '#ffffff'
}

const extremeWindLabels: Record<number, string> = {
  1: 'Very Low',
  2: 'Low',
  3: 'Moderate',
  4: 'High',
  5: 'Very High',
}

export const ExtremeWindScoreBadge = createHazardScoreBadge({
  labels: extremeWindLabels,
  // palette: scoreColor,
})
